export default __webpack_public_path__ + "static/media/lat-pulldown.ce53ec6c.jpg";